export enum CurrencyCode {
    EUR = 'EUR'
}
